import { render, staticRenderFns } from "./overview-my-account.vue?vue&type=template&id=6107af1c&scoped=true&"
import script from "./overview-my-account.vue?vue&type=script&lang=js&"
export * from "./overview-my-account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6107af1c",
  null
  
)

export default component.exports